import { render, staticRenderFns } from "./PptLayout.vue?vue&type=template&id=45ea3748&scoped=true&"
import script from "./PptLayout.vue?vue&type=script&lang=js&"
export * from "./PptLayout.vue?vue&type=script&lang=js&"
import style0 from "./PptLayout.vue?vue&type=style&index=0&id=45ea3748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ea3748",
  null
  
)

export default component.exports